import {
  GET_USER,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILURE,
  ADD_USER,
  ADD_USER_SUCCESS,
  ADD_USER_FAILURE,
  UPDATE_USER_STATUS,
  UPDATE_USER_STATUS_SUCCESS,
  UPDATE_USER_STATUS_FAILURE,
  GET_THEME,
  GET_THEME_SUCCESS,
  GET_THEME_FAILURE,
  GET_USER_SERVICES,
  GET_USER_SERVICES_SUCCESS,
  GET_USER_SERVICES_FAILURE,
  IMPORT_USER_DATA,
  IMPORT_USER_DATA_SUCCESS,
  IMPORT_USER_DATA_FAILURE,
  GET_QUESTION_DETAILS_FAILURE,
  DOWNLOAD_CSV_USERS,
  DOWNLOAD_CSV_USERS_SUCCESS,
  DOWNLOAD_CSV_USERS_FAILURE,
} from "../Constants";

const init = {
  data: {},
  delete_data: {},
  edit_data: {},
  add_data: {},
  update_data: {},
  import_data: {},
  theme_data: {},
  user_services: {},
  csv_data: {},
};

const UserReducer = (state = init, action) => {
  switch (action.type) {
    case GET_USER:
      return { ...state, loading: true };
    case GET_USER_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case GET_USER_FAILURE:
      return { ...state, loading: false, data: action.payload };
    case DELETE_USER:
      return { ...state, loading: true };
    case DELETE_USER_SUCCESS:
      return { ...state, loading: false, delete_data: action.payload };
    case DELETE_USER_FAILURE:
      return { ...state, loading: false, delete_data: action.payload };
    case EDIT_USER:
      return { ...state, loading: true };
    case EDIT_USER_SUCCESS:
      return { ...state, loading: false, edit_data: action.payload };
    case EDIT_USER_FAILURE:
      return { ...state, loading: false, edit_data: action.payload };
    case ADD_USER:
      return { ...state, loading: true };
    case ADD_USER_SUCCESS:
      return { ...state, loading: true, add_data: action.payload };
    case ADD_USER_FAILURE:
      return { ...state, loading: false, add_data: action.payload };
    case UPDATE_USER_STATUS:
      return { ...state, loading: true };
    case UPDATE_USER_STATUS_SUCCESS:
      return { ...state, loading: false, update_data: action.payload };
    case UPDATE_USER_STATUS_FAILURE:
      return { ...state, loading: false, update_data: action.payload };
    case IMPORT_USER_DATA:
      return { ...state, loading: true };
    case IMPORT_USER_DATA_SUCCESS:
      return { ...state, loading: false, import_data: action.payload };
    case IMPORT_USER_DATA_FAILURE:
      return { ...state, loading: false, import_data: action.payload };
    case GET_THEME:
      return { ...state, loading: true };
    case GET_THEME_SUCCESS:
      return { ...state, loading: false, theme_data: action.payload };
    case GET_THEME_FAILURE:
      return { ...state, loading: false, theme_data: action.payload };
    case GET_USER_SERVICES:
      return { ...state, loading: true };
    case GET_USER_SERVICES_SUCCESS:
      return { ...state, loading: false, user_services: action.payload };
    case GET_USER_SERVICES_FAILURE:
      return { ...state, loading: false, user_services: action.payload };
    case GET_QUESTION_DETAILS_FAILURE:
      return { ...state, loading: false, user_services: action.payload };
    case DOWNLOAD_CSV_USERS:
      return { ...state, loading: true, csv_data: action.payload };
    case DOWNLOAD_CSV_USERS_SUCCESS:
      return { ...state, loading: false, csv_data: action.payload };
    case DOWNLOAD_CSV_USERS_FAILURE:
      return { ...state, loading: false, csv_data: action.payload };
    default:
      return state;
  }
};

export default UserReducer;
